/* eslint-disable complexity */
import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import PropTypes from 'prop-types'
import { InfoButton } from 'components/buttons'
import Loader from 'components/Loader'
import { submitReservation } from 'cart/actions'
import { getRegItem } from 'store/api'
import AddToCartModal from 'cart/components/add-to-cart-modal'
import FundThisGiftModal from 'registry/components/modals/fund-this-gift-modal'
import * as blUrls from 'lib/urls'

const GiftGiverAction = ({ regItemId, registryId }) => {
  const {
    isLoading,
    isError,
    data: regItem,
  } = useQuery({
    queryKey: ['regItem', regItemId, registryId],
    queryFn: () => getRegItem(regItemId, registryId),
  })
  const [showAddToCartModal, setShowAddToCartModal] = useState(false)
  const [showFundingModal, setShowFundingModal] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  const showFundThisGiftAction =
    regItem?.isGroupGift && !regItem?.quantityPurchased
  // non-group-gift or unfunded group gift available on babylist
  const showGiveThisGiftAction =
    !!regItem &&
    !regItem.disableReservations &&
    (!regItem.isGroupGift ||
      (regItem.isGroupGift &&
        !regItem.fundedAmount &&
        regItem.isAvailableOnBabylist))

  const openAddToCartModal = () => {
    setSubmitting(true)
    setShowAddToCartModal(true)
  }

  const closeAddToCartModal = () => {
    setSubmitting(false)
    setShowAddToCartModal(false)
  }

  const openFundingModal = () => {
    setSubmitting(true)
    setShowFundingModal(true)
  }

  const closeFundingModal = () => {
    setSubmitting(false)
    setShowFundingModal(false)
  }

  return (
    <>
      {showAddToCartModal ? (
        <AddToCartModal
          regItem={regItem}
          onHide={closeAddToCartModal}
          onSubmit={submitReservation}
        />
      ) : null}
      <FundThisGiftModal
        show={showFundingModal}
        regItem={regItem}
        onHide={closeFundingModal}
      />
      <div className="mvl" style={{ minHeight: '32 px', position: 'relative' }}>
        {isLoading && <Loader className="center-block" />}
        {showFundThisGiftAction && (
          <InfoButton
            block
            className="mtm"
            onClick={openFundingModal}
            submitting={submitting && showFundingModal}
          >
            Fund This Gift
          </InfoButton>
        )}
        {showGiveThisGiftAction && (
          <>
            <InfoButton
              block
              className="mtm"
              onClick={openAddToCartModal}
              rel="nofollow"
              submitting={submitting && showAddToCartModal}
              disabled={!regItem.isAvailableOnBabylist}
            >
              Add to Cart
            </InfoButton>
            {!regItem.isAvailableOnBabylist && (
              <small className="block text-center xsmall pam">
                Out of Stock
              </small>
            )}
          </>
        )}
        {isError && (
          <InfoButton
            block
            empty
            className="mtm"
            href={blUrls.registryViewAsGuestPathFromId(registryId)}
          >
            Return to Registry
          </InfoButton>
        )}
      </div>
      <hr className="mtl" />
    </>
  )
}

GiftGiverAction.propTypes = {
  regItemId: PropTypes.number.isRequired,
  registryId: PropTypes.number.isRequired,
}

export default GiftGiverAction
